import { Navigate } from "react-router-dom";
import { useProfile } from "features/Authentication/hooks/useProfile";

const AuthProtected = ({ children }: any) => {
  const { user, token, loading } = useProfile();

  if (loading) {
    return null;
  }

  if (!token || !user) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export default AuthProtected;
